import { render } from "./FullscreenComparison.vue?vue&type=template&id=5d59c8e4&scoped=true"
import script from "./FullscreenComparison.vue?vue&type=script&lang=js"
export * from "./FullscreenComparison.vue?vue&type=script&lang=js"

import "./FullscreenComparison.vue?vue&type=style&index=0&id=5d59c8e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d59c8e4"]])

export default __exports__